import { API } from '../../../../common/api/constants';

// CRUD

// ПОЛУЧИТЬ ВСЕ ЗАЯВКИ GET
export const GET_ALL_REQUESTS = `${API}/requests?profile_id=`;
// export const GET_ALL_REQUESTS = `${API}/requests`;

// ПОЛУЧИТЬ ВСЕ ЗАЯВКИ ПО ФИЛЬТРУ
export const GET_FILTER_REQUESTS = `${API}/requests/filter/`;

// ПОЛУЧИТЬ ЗАЯВКИ ПО ID ПРОФИЛЯ
export const GET_REQUEST_BY_PROFILE = `${API}/request/profile/`;

// ОТФИЛЬТРОВАТЬ ЗАЯВКИ ПО ПАРАМЕТРАМ, ПЕРЕДАЕТСЯ МАССИВ ПАРАМЕТРОВ - GET
export const FILTER_REQUESTS = `${API}/requests/filter`;

// ПОЛУЧИТЬ ЗАЯВКУ GET по ID
export const GET_REQUEST = `${API}/request/`;

// Получить заявку, привязанную к профилю, по ID
// /request/{request_id}/profile/{profile_id} прописано в самом запросе getRequestRequest

// ДОБАВИТЬ ЗАЯВКУ POST
export const CREATE_REQUEST = `${API}/request`;

// РЕДАКТИРОВАТЬ ЗАЯВКУ PUT передается ID
export const UPDATE_REQUEST = `${API}/request`;

// УДАЛИТЬ ЗАЯВКУ DELETE передается ID
export const DELETE_REQUEST = `${API}/request`;

// ПОЛНОТЕКСТОВЫЙ ПОИСК ПО ЗАЯВКАМ
export const SEARCH_REQUEST = `${API}/requests/search`;

// ПОЛУЧИТЬ ПРОФИЛИ
export const GET_PROFILES = `${API}/requests/profiles`;

// ПОЛУЧИТЬ СПИСОК ТИПОВ ЗАЯВОК И ИХ КОЛИЧЕСТВО
export const GET_COUNTS = `${API}/requests/counts`
